module.exports = __webpack_public_path__ + "media/images/app/homepage/header_woman-eb4c79f3a697fe260475f3bdc1cfb350.webp";